import { useTranslation } from "react-i18next";

import {
  PageEyebrowLink,
  PageHeader,
  ShowNotifiction,
  Skeleton,
} from "@/components/ui";

import { useFetchNotificationsQuery } from "@/hooks";
import { convertTimestampToTime, formatDate } from "@/utils";
import { Pagination } from "@/components/common";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

export function Notifications() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const page = searchParams.get("page");
  const read = searchParams.get("read");
  const unread = searchParams.get("unread");

  const { data: notifications, isLoading, refetch } = useFetchNotificationsQuery({ page, read, unread });

  useEffect(() => {
    refetch()
  }, [page, refetch])

  return (
    <section className="space-y-5">
      <PageHeader
        eyebrow={
          <PageEyebrowLink to="/settings/account">Conta pessoal</PageEyebrowLink>
        }
        title={t("LABEL.notifications")}
        lede="Os avisos que a clínica recebeu, do mais recente ao mais antigo."
      />

      <main className="bg-white border border-zinc-200/50 p-5 rounded-xl w-full space-x-3">
        <div className="flex flex-col gap-1.5">
          {isLoading || !notifications
            ? Array.from({ length: 10 }).map((_, index) => (
              <Skeleton key={index} className="h-52 w-full rounded-lg" />
            ))
            : notifications.items.map((notification) => (
              <ShowNotifiction
                id={notification.id}
                title={notification.title}
                description={notification.message}
                date={notification.timestamp}
                time={notification.timestamp}
                actionPath={notification.action_path}
                actionLabel={notification.action_label}
              >
                <div
                  key={notification.id}
                  data-unread={!notification.read_at}
                  className="py-3 px-2 border-b border-dashed flex items-start justify-between text-sm cursor-pointer data-[unread=true]:bg-teal-100/50 rounded relative"
                >
                  <div className="space-y-1">
                    <h3 className="text-base text-zinc-600 font-semibold">
                      {notification.title}
                    </h3>
                    <p className="text-zinc-500 font-medium">
                      {notification.message}
                    </p>
                  </div>
                  <div className="space-y-1 text-end text-zinc-500">
                    <p className="font-medium">
                      {formatDate(notification.timestamp, false, true)}
                    </p>
                    <p>{convertTimestampToTime(notification.timestamp)}</p>
                  </div>

                  {!notification.read_at && (
                    <span className="absolute flex h-2 w-2 top-5 right-4">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-600 opacity-75" />
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600" />
                    </span>
                  )}
                </div>
              </ShowNotifiction>
            ))}
        </div>
        {notifications && <Pagination data={notifications.data} />}
      </main>
    </section>
  );
}
